import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const createDirectRelationship = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation createDirectRelationship($relationship: RelationshipInput!) {
        createDirectRelationship(relationship: $relationship) { id message error }
      }
      `),
      variables: { relationship: data }
    })
  return response.data.createDirectRelationship
}

export const updateDirectRelationship = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation updateDirectRelationship($relationship: RelationshipInput!) {
        updateDirectRelationship(relationship: $relationship) {
          message error
        }
      }
      `),
      variables: { relationship: data }
    })
  return response.data.updateDirectRelationship
}

export const deleteDirectRelationship = async (id) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation deleteDirectRelationship($relationId: Int!) {
        deleteDirectRelationship(relationId: $relationId) { message error lowLevelErrorMessage }
      }`),
      variables: { relationId: id }
    })
  return response.data.deleteDirectRelationship
}

export const createDirectRelationshipDisplayField = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation createDirectRelationshipDisplayField($field: RelationDisplayField!) {
        createDirectRelationshipDisplayField(field: $field) { id message error }
      }
      `),
      variables: { field: data }
    })
  return response.data.createDirectRelationshipDisplayField
}

export const deleteDirectRelationshipDisplayField = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation deleteDirectRelationshipDisplayField($relationId: Int!, $fieldId: Int!) {
        deleteDirectRelationshipDisplayField(relationId: $relationId, fieldId: $fieldId) { message error }
      }
      `),
      variables: { relationId: data.relationId, fieldId: data.id }
    })
  return response.data.deleteDirectRelationshipDisplayField
}
